export const comment = {
  singular: "Comment",
  plural: "Comments",
  noComment: "No comment",
  form: {
    field: {
      placeholder: "Add a comment...",
    },
    actions: {
      submit: "Send",
      cancel: "Cancel",
    },
    successMessage: "Comment saved successfully",
  },
};
